import React from 'react';
import style from './AnamneseInfo.module.css';
import parts from '../../moduleCard/moduleParts.module.css';
import CalendarConfig from '../../../../../consts/CalendarConfig';
import CustomButton from '../../../../../components/buttons/CustomButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { DataProviderInstance } from '../../../../../api/DataProvider';
import { anamnesisTemplateLabel, parseAnamnesisAnswers } from '../anamnesisAnswers';

/**
 * Uma anamnese: cabeçalho com o nome do modelo e a data, depois uma linha
 * "Pergunta: resposta" por item. `isCurrent` marca a anamnese deste atendimento.
 */
const AnamneseInfo = ({ data, onEdit, isCurrent = false }) => {
    const { CompanyConfig } = DataProviderInstance();
    const list = parseAnamnesisAnswers(data);
    const title = anamnesisTemplateLabel(CompanyConfig, data);
    const formattedDate = data.createdAt ? CalendarConfig.GetDDMMAAAA(data.createdAt) : '';

    return (
        <div className={parts.item}>
            <div className={parts.itemRow}>
                <div className={parts.chips}>
                    <span className={parts.itemTitle}>{title}</span>
                    {formattedDate && <span className={parts.itemMeta}>{formattedDate}</span>}
                    {isCurrent && <span className={`${parts.chip} ${parts.chipAccent}`}>Deste atendimento</span>}
                </div>

                {onEdit && (
                    <CustomButton
                        label="Editar"
                        icon={<EditOutlinedIcon />}
                        onClick={onEdit}
                        variant="outlined"
                        style="primary"
                    />
                )}
            </div>

            <div className={style.list}>
                {list.map((item, index) => (
                    <div key={index} className={style.line}>
                        <span className={style.question}>{item.label}</span>
                        <span className={item.answer ? style.answer : style.answerEmpty}>
                            {item.answer || 'Não informado'}
                        </span>
                        {item.observation && (
                            <span className={style.observation}>
                                Observação: {item.observation}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AnamneseInfo;
